/*
 * EkycPage Messages
 *
 * This contains all the text for the EkycPage container.
 */

export const scope = 'app.containers.EkycPage';

export default ({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'kyc1',
    description: 'Title Heading',
  },
  subHeader: {
    id: `${scope}.subHeader`,
    defaultMessage: ' ',
    description: 'Sub Heading',
  },
  inputsHelperText: {
    aadhar:
      'kyc35',
  },
  buttonText: {
    agree: 'kyc16',
    continue: 'kyc16',
  },
});
